import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
const SERVER_URL = `${process.env.REACT_APP_SITEURL}`;

const SlideShow = ({ handleTutorialSlide }) => (

    <Carousel autoPlay showThumbs={false} showArrows infiniteLoop >
        <div>
            <img alt="" src={`${SERVER_URL}/img/slider/slide1.png`} />
            <p className="legend" style={{ cursor: "pointer" }} onClick={() => { handleTutorialSlide(1) }}>تماشای جدیدترین فیلم های دنیا با دو زیرنویس همزمان</p>
        </div>
        <div>
            <img alt="" src={`${SERVER_URL}/img/slider/slide2.png`} />
            <p className="legend" style={{ cursor: "pointer" }} onClick={() => { handleTutorialSlide(2) }}>یادگیری زبان با استفاده از محبوب ترین سریال ها</p>
        </div>
        <div>
            <img alt="" src={`${SERVER_URL}/img/slider/slide3.png`} />
            <p className="legend" style={{ cursor: "pointer" }} onClick={() => { handleTutorialSlide(3) }}>دانلود زیرنویس های فارسی و انگیسی فیلم ها و سریال های مختلف</p>
        </div>
        <div>
            <img alt="" src={`${SERVER_URL}/img/slider/slide4.png`} />
            <p className="legend" style={{ cursor: "pointer" }} onClick={() => { handleTutorialSlide(4) }}>دیکشنری سریع و ذخیره لغت</p>
        </div>
        <div>
            <img alt="" src={`${SERVER_URL}/img/slider/slide5.png`} />
            <p className="legend" style={{ cursor: "pointer" }} onClick={() => { handleTutorialSlide(5) }}>سطح بندی لغات</p>
        </div>
        <div>
            <img alt="" src={`${SERVER_URL}/img/slider/slide6.png`} />
            <p className="legend" style={{ cursor: "pointer" }} onClick={() => { handleTutorialSlide(6) }}>یادگیری لغات سخت و مرور لغات لایتنر</p>
        </div>
        <div>
            <img alt="" src={`${SERVER_URL}/img/slider/slide7.png`} />
            <p className="legend" style={{ cursor: "pointer" }} onClick={() => { handleTutorialSlide(7) }}>لایتنر متصل به برنامه</p>
        </div>
    </Carousel>
);
export default SlideShow
